// @ts-generator-hash: b75035cd0fb54702f63d93c16b5a55f569228deb8d3c6b1de54b23ba738e3a7a
// Generation date: 6/7/2025 6:47:21 PM
// Auto-generated by CSharpToTypeScriptConverter
// Based on type: C06Camera.DL.Helpers.GrantCommentAudienceType
export enum GrantCommentAudienceType {
  All = 0,
  GranteeOnly = 1,
  NIHOnly = 2,
}
